<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'statementsEdit',
    components: {
      baseEdit,
    },
  };
</script>
